<div class="value" *ngFor="let val of value">{{val | date: 'HH:mm'}}</div>
<div class="value" *ngIf="!value?.length">-</div>
